class Popup {
  constructor() {
    document.querySelectorAll(".op-popup").forEach(popup => this.new_popup(popup))
  }
  new_popup($popup) {
    const popupDialog = $popup.querySelector('.op-popup__dialog')
    const openPopup = $popup.querySelector('.op-popup__open')
    const closePopup = $popup.querySelector('.op-popup__close')
    
    openPopup.addEventListener('click', () => {
      popupDialog.showModal()
    })
    closePopup.addEventListener('click', () => {
      popupDialog.close()
    })
  }

  
}
export default Popup